// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__c3BC8","right":"styles_right__3dABl"};